module.exports = __webpack_public_path__ + "img/sp-logo-eq.8bc9fccf.png";